<template>
    <Fragment>
        <div class="selected-reseller">
            <ResellerBlock
                :reseller="reseller.company_name"
                :id="reseller.id"
                :clientsCount="reseller.clients.length"
                :options="true"
                :active="reseller.active === 1"
                @deleteReseller="$emit('deleteReseller')"
                @deactivateReseller="$emit('deactivateReseller')"
                :logo="reseller.logo"
                @activateReseller="$emit('activateReseller')"
            />

            <div class="selected-reseller--information" :class="{'inactive': !reseller.active}">
                <div class="selected-reseller--information--block">
                    <h5>{{ t('general.company') }}</h5>
                    <p>{{ reseller.company_name }}</p>
                    <p>{{ reseller.street }}</p>
                    <p>{{ reseller.zipcode }}, {{ reseller.city }}</p>
                    <p>{{ reseller.phone }}</p>
                    <p>{{ reseller.website }}</p>
                </div>

                <div class="selected-reseller--information--block">
                    <h5>{{ t('general.contact_information') }}</h5>
                    <p>{{ reseller.contact_name }}</p>
                    <p>{{ reseller.phone }}</p>
                    <p>{{ reseller.email }}</p>
                </div>

                <div class="selected-reseller--information--block">
                    <h5>{{ t('general.extra_information') }}</h5>
                    <p>{{ reseller.iban }}</p>
                    <p>{{ reseller.kvk }}</p>
                    <p>{{ reseller.btw }}</p>
                </div>

                <div class="selected-reseller--information--block">
                    <h5>{{ t('auth.login_as.reseller') }}</h5>
                    <button :disabled="!reseller.active" class="button button--rounded" @click="loginAsReseller(reseller.id)">{{ t('auth.login') }}</button>
                </div>
            </div>
        </div>

        <div class="selected-reseller-clients" :class="{'inactive': !reseller.active}">
            <Table>
                <template slot="thead">
                    <tr :class="{'inactive': !reseller.active}">
                        <th>{{ t('resellers.dashboard.table.company') }}</th>
                        <th>{{ t('resellers.dashboard.table.webshops') }}</th>
                        <th>{{ t('resellers.dashboard.table.feeds') }}</th>
                        <th>{{ t('resellers.dashboard.table.connections') }}</th>
                        <th>{{ t('resellers.dashboard.table.subscriptions') }}</th>
                        <th>{{ t('resellers.dashboard.table.status') }}</th>
                        <th></th>
                    </tr>
                </template>

                <template slot="tbody" class="resellers-tbody">
                    <tr
                        v-for="(client, index) in reseller.clients"
                        :key="index"
                        :class="{'inactive': !reseller.active}"
                    >
                        <td>{{ client.company_name }}</td>
                        <td>{{ client.webshops }}</td>
                        <td>{{ client.feeds }}</td>
                        <td>{{ client.connections }}</td>
                        <td>{{ clientSub(client.subscription) }}</td>
                        <td>{{ client.status }}</td>
                        <td>
                            <i class="fal fa-users-cog" @click="changeReseller(client)"></i>
                            <!-- <button :disabled="!client.status" class="table-action-btn">
                                <i class="fal fa-edit"></i>
                            </button>
                            <button :disabled="!client.status" class="table-action-btn">
                                <i class="fal fa-user-check"></i>
                            </button>
                            <button :disabled="!client.status" class="table-action-btn">
                                <i class="fal fa-trash-alt"></i>
                            </button> -->
                        </td>
                    </tr>

                    <tr v-if="!reseller.clients.length">
                        <td colspan="7">{{ t('general.no_results_found') }}</td>
                    </tr>
                </template>
            </Table>
        </div>
    </Fragment>
</template>
<script>
import swal from 'sweetalert';
import Swal2 from 'sweetalert2';

import { Fragment } from 'vue-fragment';
import Ghost from '@/classes/Ghost';
import handleError from '@/helpers/error';
import Table from '@/components/Table/Table';
import { get, post } from '@/helpers/http';

import ResellerBlock from './ResellerBlock';

export default {
    name: 'ResellerInformation',

    props: ['reseller'],

    components: {
        Fragment,
        ResellerBlock,
        Table,
    },

    data() {
        return {
            resellers: [],
        };
    },

    created() {
        this.getResellers();
    },

    methods: {

        getResellers() {
            get({
                url: `${this.$API_URL}/api/admin/resellers?paginate=1000`,
            })
                .then((response) => {
                    this.resellers = response.data.data;
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        loginAsReseller(resellerId) {
            // Get user id based on resellerId
            Ghost.login({
                type: 'Reseller',
                id: resellerId,
            })
                .then(() => this.$router.go())
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        clientSub(sub) {
            if (sub === null) {
                return '';
            }
            return sub.subscribed_till;
        },

        changeReseller(client) {
            // const translationString = this.$translate.text('general.resend_invitation.explanation');
            Swal2.fire({
                title: 'Select a reseller',
                input: 'select',
                inputOptions: this.filtersresellers,
                inputPlaceholder: 'Select a reseller',
                confirmButtonText: 'Switch',
                confirmButtonColor: '#FECB18',
                showCancelButton: true,
            })
                .then(reseller => {
                    if (reseller.value === undefined || reseller.value === '') return null;
                    // Make the call
                    post({
                        url: `${this.$API_URL}/api/admin/resellers/${reseller.value}/transfer-client`,
                        data: {
                            clientId: client.id,
                        },
                    })
                        .then(() => {
                            swal({
                                title: this.$translate.text('alert.title.succes'),
                                text: this.$translate.text('general.switch.reseller'),
                            });
                            this.$emit('reloadResellers');
                        })
                        .catch((error) => {
                            handleError({
                                error,
                                message: this.$translate.text('alert.whoops'),
                            });
                        });
                });
        },
    },

    computed: {
        filtersresellers() {
            const filterresellers = {};
            this.resellers.forEach(item => {
                filterresellers[item.id] = item.company_name;
            });

            return filterresellers;
        },
    },

};
</script>

<style lang="scss" scoped>
.selected-reseller {
    margin-bottom: 0px;
    display: grid;
    grid-template-columns: 1fr 4fr;
    grid-gap: 8px;

    margin-bottom: 8px;
    margin-top: 16px;

    &--information {
        display: grid;
        grid-template-columns: 1fr;
        grid-gap: 8px;
        background-color: white;
        border-radius: 5px;
        padding: 16px;

        @media(min-width: 992px) {
            grid-template-columns: 1fr 1fr;
        }

        @media(min-width: 1200px) {
            grid-template-columns: 1fr 1fr 1fr 1fr;
        }

        h5, p {
            margin-bottom: 8px;
        }
    }
}

.selected-reseller-clients {
    background-color: white;
    border-radius: 5px;
    padding: 16px;
    margin-bottom: 32px;
}

.selected-reseller--information.inactive {
    opacity: 0.5;
}

.selected-reseller-clients.inactive {
    background-color: rgba(255, 255, 255, 0.5)
}

tr.inactive {
    color:rgba(0, 0, 0, 0.5)
}
</style>
